export const checkout: object = {
  checkoutAddress: {
    shippingAddress: 'Shipping Address',
    selectYourShippingAddress: 'Select your Shipping Address',
    defaultShippingAddress: 'Default Shipping Address',
    verifyYourAddress: 'Verify your address',
    ensureAccuracySuggestChange:
      'To ensure delivery accuracy, we suggest the change selected below.',
    chooseAddressToUse: 'Please choose which address you would like to use:',
    suggestedAddress: 'Suggested address',
    enteredAddress: 'Entered address',
    addNewAddress: 'Add New Address',
    shipToThisAddress: 'Ship to this address',
    editAddress: 'Edit address',
    saveAddress: 'Save address',
  },
  checkoutOrderConfirmation: {
    confirmationOfOrder: 'Confirmation of Order:',
    thankYou: 'Thank you for your order!',
    invoiceHasBeenSentByEmail:
      'An invoice has been sent by email. You should receive it soon.',
    orderItems: 'Order Items',
    orderPlacedSuccessfully: 'Order placed successfully',
    createAccount: 'Create an account?',
    createAccountForNext:
      'Create an account for <{{email}}> for a faster checkout on your next visit.',
    providedBy: 'Provided by',
    sapStoreId: 'SAP Store ID:',
    your: 'Your',
    po: 'PO',
    hyphenNumber: '-Number:',
    purchaseOrder: 'Purchase Order',
  },
  checkoutReview: {
    review: 'Review Order Details',
    orderItems: 'Order Items',
    confirmThatRead: 'By placing the order you agree to the',
    placeOrder: 'Place Order',
    termsAndConditions: 'terms and conditions',
    editShippingAddress: 'Edit shipping address',
    editShippingMethod: 'Edit shipping method',
    editPaymentMethod: 'Edit payment method',
    total: 'Total:',
    totalWithTax: 'Total with Tax:',
    estimatedTax: 'Estimated Tax:',
    estimatedTaxError: 'Could not be calculated',
    initialCost: 'Initial Cost:',
    initialCostTooltipTitle: 'View Initial cost details',
    initialCostTooltip:
      'There is no upfront cost for this solution. You will be billed based on usage.',
    importantTaxInfo: 'Important tax info',
    importantTaxInfoTooltip: 'This estimate is for informational purposes only and should not be considered definitive. Estimated tax may or may not be applied to your SAP invoice, depending on the specific terms of your transaction.',
    excludingTax: 'Excluding tax',
    paymentSection: 'Payment',
    contactsSection: 'Contractual Contacts',
    summary: 'Pricing Summary',
    poNumber: 'PO-Number',
    startDateHasBeenUpdated:
      'The start date of <strong>{{productName}} ({{productCode}})</strong> has been adjusted to <strong>{{date}}</strong> as the previously defined start date is no longer valid.',
    error: {
      orderHistoryProcessingNotFinished:
        {
          message: 'Your order is being processed, please wait for completion before starting a new order. If you have any questions, please ',
        },
      systemErrorTryAgainLater: {
        message:
          'An error occurred while placing the order, please try again and contact us if the error persists.',
      },
      threeDsFailure: {
        message: 'An error occurred while processing 3DS challenge, use another payment method or try again.',
      },
      ccLimitExceeded: {
        message:
          'This transaction cannot be completed, as the amount exceeds our limit purchasable by credit card. Please change your payment' +
          ' method to invoice.',
        button: 'Edit Payment Method'
      },
      issueWithProduct: {
        message:
          'It seems there’s been an issue with product in your cart. Please contact us to proceed.',
      },
      paymentRejected: {
        message:
          'An error occurred while placing order, please verify credit card info and try again.',
      },
      stripeProcessing: {
        message:
          'We are currently facing issues processing payments.',
      },
      taxCalculation: {
        card:
          'Estimated tax cannot be calculated at this time, we are unable to complete your purchase. Please try again shortly.',
        account:
          'Estimated tax cannot be calculated at this time. Your invoice will show the actual tax and new order total, which may differ from the total displayed below.',
      },
      startDateNeedsAdjustment: {
        message: 'To complete your purchase, your defined start date for <strong>{{productName}}</strong> must be on or after the current date. Please',
        button: 'edit start date'
      },
      termsConditions: {
        message: 'Currently unable to display Terms and Conditions',
        secondaryMessage: 'We are working to resolve this issue. Please try again later.',
      },
      prerequisiteRequired: {
        message: 'Your current selection requires the following prerequisite(s). Please ensure your organization has licensed the required solutions or change your configuration.<br/><br/><b>{materialName} has prerequisites:</b><br/><br/><ul>'
      },
    },
    codes: {
      VAL_0001:
        'We encountered an issue with your account. (Error Code: {{code}})',
      VAL_0002:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0003:
        'We encountered an issue with your account. (Error Code: {{code}})',
      VAL_0004:
        'Your account does not have buyer authorization. (Error Code: {{code}})',
      VAL_0005:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0006:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0007:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0008:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0009:
        'We encountered an issue with your existing contracts. (Error Code: {{code}})',
      VAL_0010:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0011:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0012:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0013:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0014:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0015:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0016:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0017:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0018:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0019:
        'We encountered an issue with the quantity value in your order(s). Please update the value(s) and try again. (Error Code: {{code}})',
      VAL_0020:
        'The start date of (Product Name + ID) has been adjusted to (Today\'s date) as the previously defined start date is no longer valid. (Error Code: {{code}})',
      VAL_0021:
        'We encountered an issue with the start date in your order(s). Please update the value(s) and try again. (Error Code: {{code}})',
      VAL_0022:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0023:
        'We encountered an issue with the end date in your order(s). Please update the value(s) and try again. (Error Code: {{code}})',
      VAL_0024:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0025:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0026:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0027:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0028:
        'The referenced contract item is outdated. Please remove the item from your cart, go back to SAP for Me and add it again. (Error Code: {{code}})',
      VAL_0029:
        'We encountered an issue with the items in your cart. (Error Code: {{code}})',
      VAL_0030:
        'We encountered an issue with the end date in your order(s). The end date is invalid. Please update the value(s) and try again. (Error Code: {{code}})',
      VAL_0031:
        'We are missing your payment information for your order. Please add your payment details and try again. (Error Code: {{code}})',
      VAL_0046:
        'Your organization currently has a buying restriction activated to prevent unauthorized purchases in the SAP Store. This can be granted to you by one of <a href="https://me.sap.com/userscontacts/impcont" target="_blank">your company’s administrators</a>. Please contact your company\'s administrator to obtain SAP Store purchasing authorization.',
      VAL_0048:
        'We encountered an issue with the end date in your order(s). Please update the value(s) and try again. (Error Code: {{code}})',
      VAL_0100:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0101:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0102:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0103:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0104:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0105:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0500:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0501:
        'We encountered an issue with your order. (Error Code: {{code}})',
      VAL_0502:
        'We encountered an issue with your order. (Error Code: {{code}})',
    },
  },
  checkoutShipping: {
    shippingMethod: 'Shipping Method',
    standardDelivery: 'Standard Delivery',
    premiumDelivery: 'Premium Delivery',
  },
  checkout: {
    backToCart: 'Back to cart',
    viewProviderDetails: '{{companyName}}, View provider details',
    needHelp: 'Need Help?',
    haveQuestion: 'Have a Question?',
    startChat: 'Start Chat',
    startChatDescription: 'Get live help and chat with an SAP representative.',
    contactUs: 'Contact Us',
    contactUsDescription: 'Email us with comments, questions or feedback.',
    error: {
      refreshPage: 'refresh the page',
      contactSupport: 'contact support',
      contactUs: 'contact us',
      singleProductNotLoaded: 'Unable to load',
      please: 'Please',
      singleProductTryAgain:
        'and try again. If the issue continues, ',
      singleProductRemoveFromCart: 'or remove this item from your cart.',
      multipleProductsNotLoaded:
        'The following items could not be loaded correctly.',
      multipleProductsTryAgain: 'to try again. If the issue continues,',
      multipleProductsRemoveFromCart: ' or remove these items from your cart:',
      backEndCall: {
        message:
          'Some data could not be loaded properly. Please',
        message1:
          'page. If the issue persists, please',
        contactSupport: 'contact support.',
        refreshPage: 'refresh this'
      },
    },
    additionalSolutions: 'Additional Required Solutions',
    groupTotal: 'Group Total',
    existingCustomerAgreement:
      'Your existing customer agreement includes the following support, service or solution add-ons. When adding new licenses to your agreement, these supporting solutions are added, too.',
    allItemsInThisGroup: 'For All Items In This Group',
    someItemsInThisGroup: 'For Some Items In This Group',
    for: 'For',
    digitalNativeCheckout: {
      header: 'Secure Checkout',
      accountDetails: 'Account Details',
      buyerDetails: 'Buyer Details',
      personalDetails: 'Personal Details',
      companyDetails: 'Company Details',
      createNew: {
        contact: 'Create New Contact',
        technicalContact: 'Create New Technical Contact',
        billingContact: 'Create New Billing Contact',
        create: 'Create'
      },
      edit: {
        contact: 'Save',
        technicalContact: 'Edit Technical Contact',
        billingContact: 'Edit Billing Contact'
      },
      email: 'Business e-mail address',
      createNewLocation: 'Create New Location',
      createNewAddresss: 'Create New Address',
      createNewTechnicalContact: 'Create New Technical Contact',
      editTechnicalContact: 'Edit Billing Contact',
      noContacts: 'No {{contactType}}s in the system',
      addTechnicalContact: 'Add a Technical Contact',
      addTechnicalContactTooltip:
        'Add a contact to this order who will be SAP\'s first point of contact for technical topics, initial access, setup, and release notes. This may vary depending on the selected solution type.',
      addDifferentAccessLocationTooltip: 'Only contacts created in this checkout instance can be edited. For editing older contacts, please visit SAP4ME.',
      addTechnicalContactTooltipTitle: 'View technical contact details',
      addTechnicalContactConsent:
        'I confirm that I have obtained approval to provide this individual’s personal data to SAP.',
      technicalContact: 'Technical Contact',
      billingContact: 'Billing Contact',
      shipToAddress: 'Add a different primary Access Location',
      shipToAddressMessage: 'Dear Customer, Please verify the changes to the \'ship to\' contact and address. This action will affect your order.',
      primaryAccessLocation: 'Primary Access Location',
      payment: 'Payment',
      selectPayment: 'Select Payment Method',
      continueToCheckoutReview: 'Continue to Checkout Review',
      newContact: {
        type: 'Contact Type',
        typeOption: 'Assign {{type}} as the {{contact}}',
        department: 'a <strong>department</strong>',
        individual: 'an <strong>individual</strong>',
        error: {
          somethingWrong:
            'Service currently unavailable. Please try again later.',
          unexpectedEmailDomain:
            'The email address of this contact is not on your company’s list of approved domains. To add a new domain, please ',
          emailAlreadyExist:
            'The contact you are trying to add already exists.',
          support: 'contact support',
        },
      },
      newPrimaryAccessLocation: {
        heading: 'Create New Primary Access Location',
        submit: 'Create New Location',
        errors: {
          validation: 'Please check the information you provided and try again. If the problem persists, don’t hesitate to contact us.',
          generic: 'It seems there’s been an issue with our system. Please try again later. If the problem persists, don’t hesitate to contact us.',
        },
        tooltip: {
          address: 'Please provide the registered address of the company on whose behalf you are acting. This information will be used to identify the correct legal entity for contractual purposes and determine applicable taxes.'
        }
      },
      editAddress: {
        header: 'Edit Location',
        submitButton: 'Save',
        tooltip: {
          disabled: 'Only addresses created in this checkout instance can be edited. For editing older addresses please visit SAP4Me.'
        }
      },
      editContact: {
        header: 'Edit Contact',
        submitButton: 'Edit Contact',
        tooltip: {
          disabled: 'Only contacts created in this checkout instance can be editied. For editing older contacts please visit SAP4Me.'
        }
      },
      newBillingAddress: {
        heading: 'Create New Billing Address',
        submit: 'Create New Billing Address'
      },
      paymentType: {
        billingInformation: {
          title: 'Billing Information',
          billingContact: 'Billing Contact',
          billingAddress: 'Billing Address',
          tooltipTitle: 'View billing information details',
          tooltipContent: {
            title: 'How do we use this billing information?',
            firstLine:
              'The information you provided here will be printed on your invoice. Your final invoice will be sent by email to you or the billing contact you specified.',
            secondLine:
              'You can add a purchase reference or purchase order number to this order at the end of the checkout.',
          },
        },
        invoice: {
          string: 'Invoice',
          info: 'You will be provided with an invoice from SAP including purchase details , SAP’s bank account information as well as the due date for the payment.',
        },
        cc: {
          string: 'Credit card',
          delegoInfo: 'All credit card data is securely processed by our partner Delego Software Inc. Ireland only under applicable data protection laws. Your Credit Card Information will be saved for future purchases.',
          stripeInfo: 'All credit card data is securely processed by our partner Stripe Payments Europe, Limited only under applicable data protection laws, this means your data may be transferred, processed and stored outside of your country and as set forth in the Stripe Privacy Policy ',
          cyberSourceInfo1: 'SAP uses a third-party payment processor, Cybersource, to process payments made to us via credit cards. Cybersource\'s data centers are in the USA and Singapore. In connection with the processing of such payments, we do not retain any personally identifiable information or any financial information such as credit card account numbers. Rather, all such information is provided directly by you to Cybersource, whose use of your personal information is governed by their Data Processing Agreement which can be found here: ',
          cyberSourceInfo2: ' SAP will never receive your card account number, not even in encrypted form. SAP\'s merchant activities are certified annually by a recognized PCI auditor as PCI-DSS compliant.',
          cyberSourcePrivacyLink: 'https://www.cybersource.com/en-us/about/dpa.html',
          stripePostponedCharge: 'Your credit card will be charged on the contract start date you have selected.',
          stripePrivacyLink: 'https://stripe.com/privacy',
          stripeDisclosure: 'may be subject to disclosure as required by applicable laws. Your tokenized Credit Card Information will be saved for future purchases and recurring/subscription payments.',
          error: 'Please enter valid credit card data',
          note: 'Note: ',
          disclaimer:
            'To verify your credit card, we will request a temporary authorization of {{currencyAmount}} {{currencyIso}} on your card. Your credit card will not be charged.',
          dropdown: {
            cardNumberHidden: '****',
            addNewCard: 'Add new Card',
          },
          cancelButton: 'Cancel',
          dpaoRegisterCardError: 'PAY_001: An internal error occurred while processing the payment details. Please try again later. If the issue persists, please contact support.',
          maintenance: 'Credit Card payments not available from {{startDate}} to {{endDate}} due to system maintenance.',
          errors: {
            sessionExpired: 'Your session has expired. We have created a new one for you.',
            cyberSource: {
              authenticationFailed: 'Authentication failed. Please try again.',
              ccNumber: {
                incomplete: 'Your Card Number is incomplete',
                invalid: 'Your Card Number is invalid',
              },
              expirationDate: {
                incomplete: 'Expiration Date is incomplete',
                inThePast: 'Expiration Date can not be in the past',
                monthInvalid: 'Expiration month is invalid',
              },
              securityCode: {
                incomplete: 'Your Card Security Code is incomplete'
              },
            }
          }
        },
      },
      tax: {
        taxHeader: 'Tax Information',
        vatNumber: 'VAT Number',
        taxId: 'Tax ID',
        taxTooltipTitle: 'View TaxID details',
        taxTooltip:
          'This information is used to determine the applicable tax rate for this order.',
        taxExemption:
          'I would like to add a tax exemption document provided from my company to this order.',
        taxExemptionHeadline: 'Tax exemption document',
        fileUploadingInformationWarning1: 'Please read the ',
        fileUploadingInformationLink: 'tax exempt rules and information',
        fileUploadingInformationWarning2: ' before uploading the file.',
        dragDropHere: 'Drag and drop your file here',
        or: 'or',
        button: 'Choose File',
        remove: 'Remove File',
        modal: {
          popUpHeader: 'Tax Exempt Rules and Information',
          contentUS: 'Tax Exempt Detailed Rules and Information for US',
          contentCA: 'Tax Exempt Detailed Rules and Information for Canada',
        },
        errors: {
          fileSize: 'File size too large. Please upload a file 5MB or smaller.',
          fileType:
            'File type not supported. Please upload a PDF, image or Microsoft Office file.',
          countLimit: 'Maximum 1 file is allowed.',
          fileInfected: 'File is invalid. Please upload a different file.',
          max: 'Please enter a numeric value with the maximum of 15 decimals.',
          taxTooltipFormat: 'Format:',
          taxValidation: 'There was an error validating your tax information. Please ensure that it is in the proper format:',
          taxValidationSystem: 'Your tax information could not be validated at this time. Please try again shortly.',
          taxValidationReviewOrder: 'There was an error validating your tax information.'
        },
        warnings: {
          noAttachments: 'Please Upload your tax exemption document',
        },
      },
    },
  },
  checkoutProgress: {
    shippingAddress: 'Shipping Address',
    deliveryMode: 'Delivery mode',
    paymentDetails: 'Payment details',
    reviewOrder: 'Review order',
  },
};
